import makeStyles from "@mui/styles/makeStyles";

import { theme } from "../../../App";
const useStyles = makeStyles(() => ({
  wlcmContainer: {
    display: "flex",
    flexDirection: "column",
    maxWidth: "70%",
    margin: "0 auto",
    alignItems: "center",
    color: "#333333",
    "& .MuiFormGroup-root": {
      [theme.breakpoints.down("sm")]: {
        flexDirection: "column",
      },
    },
    "& .MuiFormControlLabel-root": {
      marginRight: 30,
      marginLeft: 10,
      [theme.breakpoints.down("md")]: {
        marginRight: 6,
        marginLeft: 6,
      },
      [theme.breakpoints.down("sm")]: {
        marginRight: 0,
        marginLeft: 0,
      },
    },
  },
  footerContainer: {
    // position: "absolute",
    bottom: 0,
    width: "100%",
    marginBottom: 10,
  },
  surveyEndImage: {
    boxSizing: "border-box",
    width: 328,
    minHeight: 190,
    marginTop: 20,
    overflow: "hidden",
    "& > img": {
      width: "100%",
      minHeight: "100%",
    },
    [theme.breakpoints.up("sm")]: {
      width: 374,
    },
  },
  welcomeHeader: {
    textAlign: "center",
    fontSize: 34,
    fontWeight: 300,
    color: "#333333",
    margin: "40px 0 40px",
    fontFamily: "Bogle-Light",
    [theme.breakpoints.up("sm")]: {
      fontSize: 48,
    },
    [theme.breakpoints.up("md")]: {
      fontSize: 60,
    },
  },
  pageContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    // height: "100vh",
    minHeight: "100vh",
    position: "relative",
    overflowY: "scroll",
    //overflow-y: scroll;
  },
  welcomeMessage: {
    fontSize: 16,
    fontColor: "#333333",
    textAlign: "center",
    marginBottom: 24,
    [theme.breakpoints.up("sm")]: {
      fontSize: 18,
    },
    [theme.breakpoints.up("md")]: {
      fontSize: 24,
      minHeight: 100,
    },
  },
  btnContainer: {
    textAlign: "center",
    marginTop: 30,
  },
  getStartedBtn: {
    textTransform: "none",
    width: 180,
    minHeight: 40,
    border: 0,
    padding: 10,
    textAlign: "center",
    borderRadius: 5,
    fontWeight: 500,
    fontSize: 14,
    marginTop: 24,
    marginBottom: 24,
  },
}));

export default useStyles;
